// extracted by mini-css-extract-plugin
module.exports = {"brandFontFamily":"\"Roboto\",Helvetica,Arial,sans-serif","container":"layout_container__8mgcn","section":"layout_section__q1Enk","row":"layout_row___Mosi"};